export default "__VITE_ASSET__049d45c1__"